// extracted by mini-css-extract-plugin
var _1 = "EmployeeAvatar_active__8a860";
var _2 = "EmployeeAvatar_disabled__264c6";
var _3 = "EmployeeAvatar_icon__e4da2";
var _4 = "EmployeeAvatar_info__1dcbf";
var _5 = "EmployeeAvatar_large__29cae";
var _6 = "EmployeeAvatar_medium__683f5";
var _7 = "EmployeeAvatar_mini__99a33";
var _8 = "EmployeeAvatar_root__e61f3";
var _9 = "EmployeeAvatar_stub__2c7a7";
var _a = "EmployeeAvatar_xmini__8ade9";
export { _1 as "active", _2 as "disabled", _3 as "icon", _4 as "info", _5 as "large", _6 as "medium", _7 as "mini", _8 as "root", _9 as "stub", _a as "xmini" }
